import React from 'react';
import { T } from 'src/shared/helpers';
import styled from 'styled-components';
import { BasicButton, DestructiveButton, PrimaryButton } from '../../widgets/buttons';
import { TaskState } from './TaskStatusBadge';

interface TaskActionsProps {
    taskState: TaskState;
    onCancel?: () => void;
    onRestart?: () => void;
    onDelete?: () => void;
    onViewDetails?: () => void;
    className?: string;
    customActions?: React.ReactNode;
    labels?: {
        cancel?: string;
        restart?: string;
        delete?: string;
        viewDetails?: string;
    };
}

const ActionButtonsContainer = styled.div`
    display: flex;
    gap: 8px;
    justify-content: flex-end;
    flex-wrap: wrap;
`;

/**
 * TaskActions - Atomic component for task action buttons
 * Automatically shows appropriate actions based on task state
 * Can be customized with custom actions and labels
 */
export const TaskActions: React.FC<TaskActionsProps> = ({ taskState, onCancel, onRestart, onDelete, onViewDetails, className, customActions, labels }) => {
    const showCancel = (taskState === 'WAITING' || taskState === 'PROCESSING') && onCancel;
    const showRestart = (taskState === 'ERROR' || taskState === 'CANCELLED' || taskState === 'PARTIAL_SUCCESS') && onRestart;
    const showDelete = onDelete;
    const showDetails = onViewDetails;

    return (
        <ActionButtonsContainer className={className}>
            {showDetails && <BasicButton onClick={onViewDetails}>{labels?.viewDetails || T._('Details', 'Admin')}</BasicButton>}
            {showCancel && <DestructiveButton onClick={onCancel}>{labels?.cancel || T._('Cancel', 'Admin')}</DestructiveButton>}
            {showRestart && <PrimaryButton onClick={onRestart}>{labels?.restart || T._('Restart', 'Admin')}</PrimaryButton>}
            {customActions}
        </ActionButtonsContainer>
    );
};

export default TaskActions;
